import React, { useEffect, useMemo, useRef, useState } from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { images } from "../../assets/img";
import "./TotalNails.css";

const phoneDisplay = "0131 221 9128";
const phoneHref = "tel:+441312219128";
const email = "totalnailsedinburgh01@gmail.com";
const bookingUrl = "https://totalnailsedinburgh.setmore.com";
const facebookUrl =
  "https://www.facebook.com/people/Total-Nails-Edinburgh/100063473086617/";
const instagramUrl = "https://www.instagram.com/totalnailsno1";
const mapUrl = "https://share.google/8fowEGTVfUrCJcMX1";
const address = "8a West Maitland Street, Edinburgh EH12 5DS";

const heroImages = [
  images.burgundyPolkaDotFrenchNails,
  images.floralPolkaDotFrenchNails,
  images.blackPolkaDotFrenchNails,
  images.burgundyCreamPolkaDotNails,
  images.redBowAccentNails,
  images.pearlChromeAlmondNails,
  images.blushPearlAlmondNails,
  images.pastelBunnyNailArt,
  images.burgundyCreamPolkaDotNailsWide,
];

const galleryImages = [
  {
    src: images.goldOutlineFrenchNails,
    alt: "Gold outline French nail design",
  },
  {
    src: images.hotPinkPolkaDotSquareNails,
    alt: "Hot pink polka dot square nails",
  },
  {
    src: images.softPinkDotAlmondNails,
    alt: "Soft pink dotted almond nails",
  },
  {
    src: images.classicWhiteFrenchManicure,
    alt: "Classic white French manicure",
  },
  {
    src: images.redHeartLipNailArt,
    alt: "Red heart and lip nail art",
  },
  {
    src: images.whiteDotLinePinkNails,
    alt: "White dotted line pink nails",
  },
  {
    src: images.blackPinkPolkaDotNails,
    alt: "Black and pink polka dot nails",
  },
  {
    src: images.pinkFloralGelNails,
    alt: "Pink floral gel nail design",
  },
  {
    src: images.roseGoldChromeStilettoNails,
    alt: "Rose gold chrome stiletto nails",
  },
  {
    src: images.nail19,
    alt: "Detailed nail art set",
  },
  {
    src: images.nail20,
    alt: "Fresh manicure design",
  },
  {
    src: images.nail21,
    alt: "Glossy nail design",
  },
  {
    src: images.nail22,
    alt: "Salon nail art design",
  },
];

const services = [
  {
    name: "Acrylic + Normal Polish",
    prefix: "",
    price: "33",
    description: "Full set acrylic extensions. Infill \u00A327. Take off & redo \u00A338.",
  },
  {
    name: "Acrylic + Gel Polish",
    prefix: "",
    price: "38",
    description: "Full set acrylic extensions. Infill \u00A333. Take off & redo \u00A343.",
  },
  {
    name: "Colour Powder",
    prefix: "",
    price: "38",
    description: "Full set colour powder. Infill \u00A333. Take off & redo \u00A343.",
  },
  {
    name: "Ombre",
    prefix: "",
    price: "40",
    description: "Full set ombre extensions. Infill \u00A335. Take off & redo \u00A345.",
  },
  {
    name: "Full Set Toes",
    prefix: "",
    price: "40",
    description: "Full set toes. Infill \u00A335. Take off & redo \u00A345.",
  },
  {
    name: "Dipping Powder (SNS) - Natural Nails",
    prefix: "",
    price: "37",
    description: "Dipping powder on natural nails. Take off & redo \u00A340.",
  },
  {
    name: "Dipping Powder (SNS) - Extension",
    prefix: "",
    price: "40",
    description: "Dipping powder extensions. Take off & redo \u00A345.",
  },
  {
    name: "Builder Gel (BIAB) - Natural Nails",
    prefix: "",
    price: "32",
    description: "Builder gel on natural nails. Infill \u00A332. Take off & redo \u00A337.",
  },
  {
    name: "Builder Gel (BIAB) - Extension",
    prefix: "",
    price: "40",
    description: "Builder gel extensions. Infill \u00A335. Take off & redo \u00A345.",
  },
  {
    name: "Normal Polish (Hands)",
    prefix: "",
    price: "17",
    description: "Normal polish application for hands.",
  },
  {
    name: "Gel Polish (Shellac) (Hands)",
    prefix: "",
    price: "24",
    description: "Gel polish application for hands.",
  },
  {
    name: "Manicure + Normal Polish",
    prefix: "",
    price: "22",
    description: "Manicure finished with normal polish.",
  },
  {
    name: "Manicure + Gel Polish",
    prefix: "",
    price: "30",
    description: "Manicure finished with gel polish.",
  },
  {
    name: "Normal Polish (Toes)",
    prefix: "",
    price: "17",
    description: "Normal polish application for toes.",
  },
  {
    name: "Gel Polish (Toes)",
    prefix: "",
    price: "25",
    description: "Gel polish application for toes.",
  },
  {
    name: "Spa Pedicure + Normal Polish",
    prefix: "",
    price: "32",
    description: "Spa pedicure finished with normal polish.",
  },
  {
    name: "Spa Pedicure + Gel Polish",
    prefix: "",
    price: "40",
    description: "Spa pedicure finished with gel polish.",
  },
  {
    name: "Take Off & Redo (Manicure / Pedicure)",
    prefix: "",
    price: "3",
    description: "Extra charge for take off and redo.",
  },
  {
    name: "Take Off Only - Gel Polish",
    prefix: "",
    price: "10",
    description: "Professional removal of gel polish.",
  },
  {
    name: "Take Off Only - BIAB / Builder Gel / Acrylic",
    prefix: "",
    price: "12",
    description: "Professional removal of BIAB, builder gel, or acrylic.",
  },
  {
    name: "French Tips",
    prefix: "from",
    price: "5",
    description: "Classic French tip finish.",
  },
  {
    name: "Chrome (Metallic)",
    prefix: "",
    price: "5",
    description: "Metallic chrome finish for a high-shine effect.",
  },
  {
    name: "Cat Eye",
    prefix: "",
    price: "5",
    description: "Magnetic cat-eye effect for a dimensional finish.",
  },
  {
    name: "Nails Art",
    prefix: "from",
    price: "5",
    description: "Creative nail art details and custom designs.",
  },
  {
    name: "Long Nails",
    prefix: "from",
    price: "3",
    description: "Extra charge for longer nail length.",
  },
  {
    name: "Diamonds",
    prefix: "from",
    price: "3",
    description: "Add sparkling diamond accents to your manicure.",
  },
  {
    name: "Multi Colour",
    prefix: "",
    price: "3",
    description: "Multi-colour polish finish.",
  },
];

const reviews = [
  {
    name: "Emily Carter",
    service: "BIAB manicure",
    initials: "EC",
    text: "Beautiful finish and such careful shaping. My nails still looked polished weeks later.",
  },
  {
    name: "Sophie Williams",
    service: "Acrylic extensions",
    initials: "SW",
    text: "The design was exactly what I wanted. Elegant, neat, and the team made the appointment feel relaxed.",
  },
  {
    name: "Amelia Thompson",
    service: "Gel polish",
    initials: "AT",
    text: "Lovely salon with a calm atmosphere. The colour choice was brilliant and the gel stayed glossy.",
  },
  {
    name: "Charlotte Evans",
    service: "Ombre extensions",
    initials: "CE",
    text: "My ombre nails were blended beautifully and shaped with so much care. I had compliments all week.",
  },
  {
    name: "Grace Mitchell",
    service: "Spa pedicure",
    initials: "GM",
    text: "A relaxing appointment from start to finish. The pedicure looked tidy, fresh, and really elegant.",
  },
  {
    name: "Isla Robertson",
    service: "Chrome nails",
    initials: "IR",
    text: "The chrome finish was flawless and so shiny. The team helped me pick the perfect soft gold tone.",
  },
  {
    name: "Olivia Brown",
    service: "Acrylic + gel polish",
    initials: "OB",
    text: "Strong, neat extensions with a gorgeous colour finish. They listened carefully to the length I wanted.",
  },
  {
    name: "Mia Anderson",
    service: "Nail art",
    initials: "MA",
    text: "The tiny details were beautiful. My set felt special without being too much for everyday wear.",
  },
  {
    name: "Hannah Wilson",
    service: "Builder gel",
    initials: "HW",
    text: "My natural nails feel stronger and look so clean. The finish was smooth and lasted really well.",
  },
  {
    name: "Lucy Taylor",
    service: "Gel polish toes",
    initials: "LT",
    text: "Quick, friendly service and the polish looked perfect for my holiday. I will definitely come back.",
  },
  {
    name: "Freya Campbell",
    service: "Dipping powder",
    initials: "FC",
    text: "The colour was rich and even, and the shape was exactly right. A really polished result.",
  },
];

function Icon({ name }) {
  const paths = {
    sparkle: (
      <>
        <path d="M12 2l1.8 6.2L20 10l-6.2 1.8L12 18l-1.8-6.2L4 10l6.2-1.8L12 2z" />
        <path d="M19 15l.9 3.1L23 19l-3.1.9L19 23l-.9-3.1L15 19l3.1-.9L19 15z" />
      </>
    ),
    phone: (
      <path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.7 19.7 0 0 1-8.6-3.1 19.1 19.1 0 0 1-5.9-5.9A19.7 19.7 0 0 1 2.1 4.2 2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1 1 .4 2 .7 2.9a2 2 0 0 1-.5 2.1L8.1 9.9a16 16 0 0 0 6 6l1.2-1.2a2 2 0 0 1 2.1-.5c.9.3 1.9.6 2.9.7A2 2 0 0 1 22 16.9z" />
    ),
    mail: (
      <>
        <path d="M4 4h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z" />
        <path d="M22 7l-10 6L2 7" />
      </>
    ),
    map: (
      <>
        <path d="M21 10c0 7-9 12-9 12S3 17 3 10a9 9 0 1 1 18 0z" />
        <path d="M12 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" />
      </>
    ),
    clock: (
      <>
        <path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20z" />
        <path d="M12 7v5l4 2" />
      </>
    ),
    users: (
      <>
        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
        <path d="M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z" />
        <path d="M22 21v-2a4 4 0 0 0-3-3.9" />
        <path d="M16 3.1a4 4 0 0 1 0 7.8" />
      </>
    ),
    award: (
      <>
        <path d="M12 15a6 6 0 1 0 0-12 6 6 0 0 0 0 12z" />
        <path d="M8.5 13.8L7 22l5-3 5 3-1.5-8.2" />
      </>
    ),
    star: (
      <path d="m12 2 3.1 6.3 6.9 1-5 4.9 1.2 6.8-6.2-3.2L5.8 21 7 14.2 2 9.3l6.9-1L12 2z" />
    ),
    chat: (
      <path d="M21 15a4 4 0 0 1-4 4H8l-5 3V7a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4v8z" />
    ),
    quote: (
      <>
        <path d="M9 7H5a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h2v-2H5V9h4V7z" />
        <path d="M21 7h-4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h2v-2h-2V9h4V7z" />
      </>
    ),
    close: (
      <>
        <path d="M18 6L6 18" />
        <path d="M6 6l12 12" />
      </>
    ),
    menu: (
      <>
        <path d="M4 7h16" />
        <path d="M4 12h16" />
        <path d="M4 17h16" />
      </>
    ),
  };

  return (
    <svg className="tn-icon" viewBox="0 0 24 24" aria-hidden="true">
      {paths[name]}
    </svg>
  );
}

function HeroSlider() {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const timer = window.setInterval(() => {
      setActiveIndex((current) => (current + 1) % heroImages.length);
    }, 4000);

    return () => window.clearInterval(timer);
  }, []);

  return (
    <div className="tn-hero-slider" aria-hidden="true">
      {heroImages.map((image, index) => (
        <div
          className={`tn-hero-slide ${index === activeIndex ? "tn-hero-slide--active" : ""}`}
          key={image}
          style={{ backgroundImage: `url(${image})` }}
        />
      ))}
    </div>
  );
}

function CountUpStat({ end, suffix, label, icon }) {
  const ref = useRef(null);
  const [value, setValue] = useState(0);
  const [hasAnimated, setHasAnimated] = useState(false);

  useEffect(() => {
    const node = ref.current;

    if (!node || hasAnimated) {
      return undefined;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) {
          return;
        }

        setHasAnimated(true);
        const startedAt = performance.now();
        const duration = 1800;

        const tick = (time) => {
          const progress = Math.min((time - startedAt) / duration, 1);
          setValue(Math.round(end * progress));

          if (progress < 1) {
            window.requestAnimationFrame(tick);
          }
        };

        window.requestAnimationFrame(tick);
      },
      { threshold: 0.4 }
    );

    observer.observe(node);
    return () => observer.disconnect();
  }, [end, hasAnimated]);

  return (
    <div className="tn-stat" ref={ref}>
      <span className="tn-stat__icon">
        <Icon name={icon} />
      </span>
      <strong>
        {value}
        {suffix}
      </strong>
      <span>{label}</span>
    </div>
  );
}

function FloatingContactButton() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="tn-floating-contact">
      {isOpen && (
        <div className="tn-contact-popover">
          <button
            className="tn-contact-popover__close"
            type="button"
            aria-label="Close contact options"
            onClick={() => setIsOpen(false)}
          >
            <Icon name="close" />
          </button>
          <a className="tn-popover-link tn-popover-link--facebook" href={facebookUrl} target="_blank" rel="noreferrer">
            Chat on Facebook
          </a>
          <a className="tn-popover-link" href={phoneHref}>
            Call Us
          </a>
        </div>
      )}
      <button
        type="button"
        className="tn-floating-contact__button"
        aria-label="Open contact options"
        aria-expanded={isOpen}
        onClick={() => setIsOpen((current) => !current)}
      >
        <Icon name="chat" />
      </button>
    </div>
  );
}

function ContactSection() {
  return (
    <section className="tn-section tn-contact" id="contact">
      <div className="tn-container">
        <div className="tn-section-heading">
          <h2>Visit Us</h2>
        </div>

        <div className="tn-contact-grid">
          <div className="tn-contact-card">
            <h3>Contact Information</h3>
            <a className="tn-contact-row" href={mapUrl} target="_blank" rel="noreferrer">
              <Icon name="map" />
              <span>{address}</span>
            </a>
            <a className="tn-contact-row" href={phoneHref}>
              <Icon name="phone" />
              <span>{phoneDisplay}</span>
            </a>
            <a className="tn-contact-row" href={`mailto:${email}`}>
              <Icon name="mail" />
              <span>{email}</span>
            </a>
            <a className="tn-contact-row" href={facebookUrl} target="_blank" rel="noreferrer">
              <Icon name="sparkle" />
              <span>Follow us on Facebook</span>
            </a>
            <a className="tn-contact-row" href={instagramUrl} target="_blank" rel="noreferrer">
              <Icon name="star" />
              <span>Follow us on Instagram</span>
            </a>
          </div>

          <div className="tn-hours-card">
            <div className="tn-hours-card__header">
              <Icon name="clock" />
              <h3>Opening Hours</h3>
            </div>
            <dl>
              <div>
                <dt>Monday - Friday</dt>
                <dd>10:00 AM - 7:00 PM</dd>
              </div>
              <div>
                <dt>Saturday</dt>
                <dd>10:00 AM - 6:30 PM</dd>
              </div>
              <div>
                <dt>Sunday</dt>
                <dd className="tn-hours-card__closed">Closed</dd>
              </div>
            </dl>
          </div>
        </div>

        <div className="tn-map-card">
          <iframe
            title="Total Nails Edinburgh map"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3278.51677961342!2d-3.215766!3d55.9465581!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4887c7bce16c9477%3A0x32c4c8903810069c!2sTotal%20Nails!5e1!3m2!1sen!2s!4v1777373324417!5m2!1sen!2s"
            loading="lazy"
            allowFullScreen
            referrerPolicy="no-referrer-when-downgrade"
          />
          <a href={mapUrl} target="_blank" rel="noreferrer">
            Open in Google Maps
          </a>
        </div>
      </div>
    </section>
  );
}

function ReviewsSection() {
  const [reviewsPerSlide, setReviewsPerSlide] = useState(3);
  const reviewSlides = useMemo(() => {
    const slides = [];

    for (let index = 0; index < reviews.length; index += reviewsPerSlide) {
      slides.push(reviews.slice(index, index + reviewsPerSlide));
    }

    return slides;
  }, [reviewsPerSlide]);
  const [activeSlide, setActiveSlide] = useState(0);
  const [dragOffset, setDragOffset] = useState(0);
  const [isDragging, setIsDragging] = useState(false);
  const dragStartX = useRef(0);
  const carouselRef = useRef(null);

  useEffect(() => {
    const updateReviewsPerSlide = () => {
      if (window.innerWidth <= 640) {
        setReviewsPerSlide(1);
      } else if (window.innerWidth <= 920) {
        setReviewsPerSlide(2);
      } else {
        setReviewsPerSlide(3);
      }
    };

    updateReviewsPerSlide();
    window.addEventListener("resize", updateReviewsPerSlide);

    return () => window.removeEventListener("resize", updateReviewsPerSlide);
  }, []);

  useEffect(() => {
    setActiveSlide((current) => Math.min(current, reviewSlides.length - 1));
  }, [reviewSlides.length]);

  useEffect(() => {
    if (isDragging) {
      return undefined;
    }

    const timer = window.setInterval(() => {
      setActiveSlide((current) => (current + 1) % reviewSlides.length);
    }, 5000);

    return () => window.clearInterval(timer);
  }, [isDragging, reviewSlides.length]);

  const startDrag = (event) => {
    dragStartX.current = event.clientX;
    setIsDragging(true);
    setDragOffset(0);
  };

  const moveDrag = (event) => {
    if (!isDragging) {
      return;
    }

    const width = carouselRef.current?.offsetWidth || 1;
    const distance = event.clientX - dragStartX.current;
    const maxDistance = width * 0.35;
    const limitedDistance = Math.max(Math.min(distance, maxDistance), -maxDistance);

    setDragOffset((limitedDistance / width) * 100);
  };

  const endDrag = () => {
    if (!isDragging) {
      return;
    }

    const threshold = 12;

    if (dragOffset <= -threshold) {
      setActiveSlide((current) => (current + 1) % reviewSlides.length);
    } else if (dragOffset >= threshold) {
      setActiveSlide((current) => (current - 1 + reviewSlides.length) % reviewSlides.length);
    }

    setIsDragging(false);
    setDragOffset(0);
  };

  return (
    <section className="tn-section tn-reviews" id="reviews">
      <div className="tn-container">
        <div className="tn-section-heading tn-reviews__heading">
          <p className="tn-eyebrow">Client Reviews</p>
          <h2>Loved by Our Clients</h2>
        </div>

        <div
          className={`tn-reviews-carousel ${isDragging ? "tn-reviews-carousel--dragging" : ""}`}
          aria-live="polite"
          ref={carouselRef}
          onPointerDown={startDrag}
          onPointerMove={moveDrag}
          onPointerUp={endDrag}
          onPointerCancel={endDrag}
          onPointerLeave={endDrag}
        >
          <div
            className="tn-reviews-track"
            style={{ transform: `translateX(calc(-${activeSlide * 100}% + ${dragOffset}%))` }}
          >
            {reviewSlides.map((slide, slideIndex) => (
              <div className="tn-reviews-slide" key={`review-slide-${slideIndex}`}>
                {slide.map((review) => (
                  <article className="tn-review-card" key={review.name}>
                    <div className="tn-review-card__quote">
                      <Icon name="quote" />
                    </div>
                    <div className="tn-review-card__stars" aria-label="5 out of 5 stars">
                      {[...Array(5)].map((_, index) => (
                        <Icon name="star" key={`${review.name}-${index}`} />
                      ))}
                    </div>
                    <p className="tn-review-card__text">&ldquo;{review.text}&rdquo;</p>
                    <div className="tn-review-card__client">
                      <span className="tn-review-card__avatar" aria-hidden="true">
                        {review.initials}
                      </span>
                      <div>
                        <h3>{review.name}</h3>
                        <p>{review.service}</p>
                      </div>
                    </div>
                  </article>
                ))}
              </div>
            ))}
          </div>
        </div>

        <div className="tn-reviews-dots" aria-label="Review slides">
          {reviewSlides.map((_, index) => (
            <button
              className={index === activeSlide ? "tn-reviews-dot tn-reviews-dot--active" : "tn-reviews-dot"}
              type="button"
              key={`review-dot-${index}`}
              aria-label={`Show review slide ${index + 1}`}
              aria-current={index === activeSlide}
              onClick={() => setActiveSlide(index)}
            />
          ))}
        </div>
      </div>
    </section>
  );
}

function SiteFooter({ onHomeClick }) {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="tn-footer">
      <a className="tn-logo tn-logo--footer" href={onHomeClick ? "#home" : "/"} onClick={onHomeClick}>
        <span className="tn-logo__mark">
          <Icon name="sparkle" />
        </span>
        <span>Total Nails</span>
      </a>
      <p>Your destination for elegant nail care in Edinburgh.</p>
      <small>
        Copyright {currentYear}{" "}
        <a className="tn-footer__credit-link" href="https://solcomarketing.com" target="_blank" rel="noreferrer">
          SOLCO Marketing
        </a>{" "}
        &{" "}
        <a className="tn-footer__credit-link" href="https://huacatluong.com" target="_blank" rel="noreferrer">
          Hua Cat Luong
        </a>
        . All rights reserved.
      </small>
    </footer>
  );
}

function PricingHeader() {
  return (
    <header className="tn-header">
      <Link className="tn-logo" to="/">
        <span className="tn-logo__mark">
          <Icon name="sparkle" />
        </span>
        <span>Total Nails</span>
      </Link>

      <nav className="tn-nav tn-nav--pricing" aria-label="Pricing navigation">
        <a className="tn-nav__cta" href={bookingUrl} target="_blank" rel="noreferrer">
          Book Now
        </a>
      </nav>
    </header>
  );
}

export default function TotalNails() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [showAllServicesMobile, setShowAllServicesMobile] = useState(false);
  const [showAllGalleryMobile, setShowAllGalleryMobile] = useState(false);
  const structuredData = useMemo(
    () => ({
      "@context": "https://schema.org",
      "@type": "BeautySalon",
      name: "Total Nails Edinburgh",
      address: {
        "@type": "PostalAddress",
        streetAddress: "8a West Maitland Street",
        addressLocality: "Edinburgh",
        postalCode: "EH12 5DS",
        addressCountry: "GB",
      },
      telephone: "+441312219128",
      email,
      openingHours: ["Mo-Fr 10:00-19:00", "Sa 10:00-18:30"],
      priceRange: "GBP GBP",
      sameAs: [facebookUrl, instagramUrl],
    }),
    []
  );

  const closeMenu = () => setMenuOpen(false);
  const scrollToSection = (sectionId) => (event) => {
    event.preventDefault();
    document.getElementById(sectionId)?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
    closeMenu();
  };

  return (
    <main className="total-nails">
      <Helmet>
        <title>Total Nails Edinburgh - Professional Nail Salon</title>
        <meta
          name="description"
          content="Total Nails Edinburgh offers professional nail care, manicures, pedicures, gel nails, BIAB, acrylics, and nail art at 8a West Maitland Street."
        />
        <meta
          name="keywords"
          content="nail salon edinburgh, manicure edinburgh, pedicure edinburgh, gel nails, nail art, total nails"
        />
        <meta property="og:title" content="Total Nails Edinburgh - Professional Nail Salon" />
        <meta
          property="og:description"
          content="Experience elegant nail care in Edinburgh with professional technicians and a luxury salon setting."
        />
        <script type="application/ld+json">{JSON.stringify(structuredData)}</script>
      </Helmet>

      <header className="tn-header">
        <a className="tn-logo" href="#home" onClick={scrollToSection("home")}>
          <span className="tn-logo__mark">
            <Icon name="sparkle" />
          </span>
          <span>Total Nails</span>
        </a>

        <button
          className="tn-menu-button"
          type="button"
          aria-label="Toggle navigation menu"
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((current) => !current)}
        >
          <Icon name="menu" />
        </button>

        <nav className={`tn-nav ${menuOpen ? "tn-nav--open" : ""}`} aria-label="Main navigation">
          <a href="#about" onClick={scrollToSection("about")}>About</a>
          <a href="#services" onClick={scrollToSection("services")}>Services</a>
          <a href="#gallery" onClick={scrollToSection("gallery")}>Gallery</a>
          <a href="#reviews" onClick={scrollToSection("reviews")}>Reviews</a>
          <Link to="/pricing" onClick={closeMenu}>Pricing</Link>
          {/* <a href="#appointment" onClick={scrollToSection("appointment")}>Appointment</a> */}
          <a href="#contact" onClick={scrollToSection("contact")}>Contact</a>
          <a className="tn-nav__cta" href={bookingUrl} target="_blank" rel="noreferrer" onClick={closeMenu}>Book Now</a>
        </nav>
      </header>

      <section className="tn-hero" id="home">
        <HeroSlider />
        <div className="tn-hero__overlay" />
        <div className="tn-hero__content">
          <p className="tn-eyebrow">Professional nail salon in Edinburgh</p>
          <h1>Total Nails</h1>
          <p className="tn-hero__subtitle">Your Destination for Elegant Nail Care</p>
          <p className="tn-hero__text">
            Experience luxury and professionalism in the heart of Edinburgh.
          </p>
          <a className="tn-button tn-button--primary" href="#contact" onClick={scrollToSection("contact")}>
            Visit Us Today
          </a>
        </div>
      </section>

      <section className="tn-section tn-about" id="about">
        <div className="tn-container tn-container--narrow">
          <h2>Welcome to Total Nails</h2>
          <p>
            At Total Nails Edinburgh, we are dedicated to providing exceptional nail care
            services in a luxurious and relaxing environment. Our team of experienced nail
            technicians combines artistic expertise with the latest techniques to deliver
            stunning results every time.
          </p>
          <p>
            Located in the heart of Edinburgh, we pride ourselves on using only premium
            products and maintaining the highest standards of hygiene and professionalism.
            Whether you are looking for a classic manicure, creative nail art, or luxurious
            spa treatments, we are here to make your nails beautiful and healthy.
          </p>
          <p>
            We believe every client deserves personalised attention and exceptional service.
            From the moment you step into our salon, you will experience elegance, comfort,
            and expert care.
          </p>

          <div className="tn-stats" aria-label="Salon statistics">
            <CountUpStat end={5000} suffix="+" label="Happy Customers" icon="users" />
            <CountUpStat end={10} suffix="+" label="Expert Technicians" icon="award" />
            <CountUpStat end={99} suffix="%" label="Good Reviews" icon="star" />
          </div>

          <div className="tn-stats-cta">
            <a className="tn-stats-cta__button" href={bookingUrl} target="_blank" rel="noreferrer">
              Book Now
            </a>
          </div>
        </div>
      </section>

      <section className="tn-section tn-section--dark" id="services">
        <div className="tn-container">
          <div className="tn-section-heading">
            <h2>Our Service</h2>
          </div>
          <div className={`tn-services-grid ${showAllServicesMobile ? "tn-services-grid--expanded" : ""}`}>
            {services.map((service) => (
              <Link className="tn-service-card" to="/pricing" key={service.name}>
                <div className="tn-service-card__top">
                  <div className="tn-service-card__title">
                    <span className="tn-service-card__icon">
                      <Icon name="sparkle" />
                    </span>
                    <h3>{service.name}</h3>
                  </div>
                  <strong>
                    {service.prefix && `${service.prefix} `}
                    &pound;{service.price}
                  </strong>
                </div>
                <p>{service.description}</p>
              </Link>
            ))}
          </div>
          <button
            className="tn-services-toggle"
            type="button"
            onClick={() => setShowAllServicesMobile((current) => !current)}
          >
            {showAllServicesMobile ? "Show fewer services" : "View all services"}
          </button>
          <a className="tn-discount" href="#contact" onClick={scrollToSection("contact")}>
            10% Student Discount Available
          </a>
        </div>
      </section>

      <section className="tn-section" id="gallery">
        <div className="tn-container">
          <div className="tn-section-heading">
            <h2>Gallery</h2>
          </div>
          <div className={`tn-gallery-grid ${showAllGalleryMobile ? "tn-gallery-grid--expanded" : ""}`}>
            {galleryImages.map((image) => (
              <a
                className="tn-gallery-card"
                href={instagramUrl}
                target="_blank"
                rel="noreferrer"
                key={image.src}
                aria-label={`Open Instagram for ${image.alt}`}
              >
                <img src={image.src} alt={image.alt} loading="lazy" />
                <span>View Instagram</span>
              </a>
            ))}
          </div>
          <button
            className="tn-gallery-toggle"
            type="button"
            onClick={() => setShowAllGalleryMobile((current) => !current)}
          >
            {showAllGalleryMobile ? "Show fewer photos" : "View all photos"}
          </button>
        </div>
      </section>

      <ReviewsSection />

      <section
        className="tn-appointment"
        id="appointment"
        style={{ backgroundImage: `url(${images.redHeartLipNailArt})` }}
      >
        <div className="tn-appointment__overlay" />
        <div className="tn-appointment__content">
          <p>appointment</p>
          <h2>Book Your Time for Nail Art</h2>
          <a className="tn-appointment__button" href={bookingUrl} target="_blank" rel="noreferrer">
            Book now
          </a>
        </div>
      </section>

      <ContactSection />
      <SiteFooter onHomeClick={scrollToSection("home")} />

      <FloatingContactButton />
    </main>
  );
}

export function PricingPage() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, []);

  return (
    <main className="total-nails">
      <Helmet>
        <title>Total Nails Edinburgh - Pricing</title>
        <meta
          name="description"
          content="View the Total Nails Edinburgh pricing list for manicures, pedicures, gel polish, acrylics, BIAB, and nail art."
        />
      </Helmet>

      <PricingHeader />

      <section className="tn-section tn-pricing-page">
        <div className="tn-container">
          <div className="tn-section-heading tn-pricing-page__heading">
            <h1>Pricing</h1>
          </div>
          <div className="tn-pricing-image-wrap">
            <img src={images.pricing} alt="Total Nails Edinburgh pricing list" />
          </div>
        </div>
      </section>

      <ContactSection />
      <SiteFooter />
      <FloatingContactButton />
    </main>
  );
}
